import React from 'react';
import { Box, Text } from '@mantine/core';
import { formatDateWithDay } from '@/helpers';
import PaperSection from '../PaperSection';
import useConfirmedSection from './useConfirmedSection';
import { EmptyList } from '../EmptyList';
import EventItem from '../EventItem/EventItem';

const ConfirmedSection: React.FC = () => {
  const { loading, error, eventsByDate } = useConfirmedSection();

  return (
    <PaperSection loading={loading} title="UPCOMING EVENTS" error={error} mt="xl">
      {eventsByDate.length ? (
        eventsByDate.map(({ events, date }) => (
          <React.Fragment key={date}>
            <Box bg="blue.1" px="sm">
              <Text size="sm">{formatDateWithDay(date)}</Text>
            </Box>
            {events.map((event) => (
              <EventItem key={event.id} event={event} completed={false} />
            ))}
          </React.Fragment>
        ))
      ) : (
        <EmptyList text="You don't have any confirmed events right now." />
      )}
    </PaperSection>
  );
};

export default ConfirmedSection;
